import questionService from "../services/questionService";
import { useMutation } from "react-query";

const useQuestionCreateMutation = (onData) => {
  return useMutation(questionService.questionCreate, {
    onSuccess: (data) => onData(data),
  });
};

const useQuestionUpdateMutation = (onData) => {
  return useMutation(questionService.questionUpdate, {
    onSuccess: (data) => onData(data),
  });
};

const useQuestionListMutation = (onData) => {
  return useMutation(questionService.questionList, {
    onSuccess: (data) => onData(data),
  });
};

const useQuestionViewMutation = (onData) => {
  return useMutation(questionService.questionView, {
    onSuccess: (data) => onData(data),
  });
};

const useQuestionListingMutationInspection = (onData) => {
  return useMutation(questionService.questionListInspection, {
    onSuccess: (data) => onData(data),
  });
};

const useQuestionViewMutationInspection = (onData) => {
  return useMutation(questionService.questionViewInspection, {
    onSuccess: (data) => onData(data),
  });
};

const useGetVesselWiseQuestions = (onData) => {
  return useMutation(questionService.getVesselWiseQuestions, {
    onSuccess: (data) => onData(data),
  });
};

const useExcludeQuestion = (onData) => {
  return useMutation(questionService.excludeQuestion, {
    onSuccess: (data) => onData(data),
  });
};

const questionQueries = {
    useQuestionCreateMutation,
    useQuestionUpdateMutation,
    useQuestionListMutation,
    useQuestionViewMutation,
    useQuestionListingMutationInspection,
    useQuestionViewMutationInspection,
    useGetVesselWiseQuestions,
    useExcludeQuestion
};

export default questionQueries;
